import { BlobServiceClient } from "@azure/storage-blob";

// Define constants here
const accountName = "ahceinvoice";
const containerName = "ahcshaml";
const sasToken = "sp=racwdl&st=2025-05-28T07:22:17Z&se=2026-07-31T15:22:17Z&sv=2024-11-04&sr=c&sig=vIY442z49dtxhiE0pXaRANuvc2scK5GsnZikO3vB49o%3D";

export const uploadFileToAzure = async (file) => {
  const blobName = `${new Date().getTime()}_${file.name}`;
  const blobServiceClient = new BlobServiceClient(`https://${accountName}.blob.core.windows.net?${sasToken}`);
 
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const blockBlobClient = containerClient.getBlockBlobClient(blobName);

  try {
    await blockBlobClient.uploadData(file, {
      blobHTTPHeaders: { blobContentType: file.type },
    });

    const publicUrl = `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`;
    return publicUrl;
  } catch (error) {
    console.error("Azure upload failed", error);
    throw new Error("Azure upload failed");
  }
};


export const deleteFileFromAzure = async (fileUrl) => {
  try {
    // Extract blobName from the fileUrl
    // Example fileUrl: https://ahceinvoice.blob.core.windows.net/ahcshaml/1685283456789_filename.jpg
    const url = new URL(fileUrl);
    const blobName = decodeURIComponent(url.pathname.split(`/${containerName}/`)[1]);

    const blobServiceClient = new BlobServiceClient(
      `https://${accountName}.blob.core.windows.net?${sasToken}`
    );

    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);

    await blockBlobClient.delete();

    console.log(`Deleted blob: ${blobName}`);
  } catch (error) {
    console.error("Azure delete failed", error);
    throw new Error("Azure delete failed");
  }
};